import { isEmpty } from '../helpers/object';
import {getRankersUserAgent} from "../constants/rankers_user_agent";

// Note to ensure that Rails `format.js` response block is run an 'Accept' request header must be set with the value 'text/javascript'.
// Eg. new Loader(url, { requestHeaders: { 'Accept': 'text/javascript' }}, callback );
export class Loader {

    static defaultXhr() {
        let xhr = new XMLHttpRequest();
        return xhr;
    }

    constructor(url, config={}, callback) {
        this.url = url || null;
        this.configure(config);
        this.setUpRankersUserAgentRequestHeader();
        this.setUpRequestedWithRequestHeader();
        this.setUpContentTypeRequestHeader();
        this.requestUrl = this.calcRequestUrl();
        this.callback = callback;
        this.xhr = Loader.defaultXhr();
        this.portionComplete = 0;
    }

    sendRequest() {
        this.xhr.abort();
        this.xhr.open(this.method, this.requestUrl);
        this.xhr.responseType = this.responseType;
        Object.keys(this.requestHeaders).forEach((key)=>{
            this.xhr.setRequestHeader(key, this.requestHeaders[key]);
        });
        this.xhr.onloadstart = this.handleLoadStart.bind(this);
        this.xhr.onloadend = this.handleLoadEnd.bind(this);
        this.xhr.onload = this.handleLoad.bind(this);
        this.xhr.addEventListener("progress", (event) => {
            if (event.lengthComputable) {
                this.portionComplete = event.loaded / event.total;
            }
        }, false);
        this.xhr.send(this.params);
    }

    configure(config) {
        this.params = null;
        this.method = "GET";
        this.requestHeaders = {};
        this.responseType = "";
        if (config && !isEmpty(config)) {
            this.params = config['params'] || this.params;
            this.method = config['method'] || this.method;
            this.requestHeaders = config['requestHeaders'] || {};
            this.responseType = config['responseType'] || "";
            this.failureCallback = config['failureCallback'] || null;
        }
    }

    setUpRequestedWithRequestHeader() {
        if (this.requestHeaders && this.requestHeaders['X-Requested-With']) { return };
        this.requestHeaders['X-Requested-With'] = getRankersUserAgent();
    }

    setUpRankersUserAgentRequestHeader() {
        if (this.requestHeaders && this.requestHeaders['X-Rankers-User-Agent']) { return }
        this.requestHeaders['X-Rankers-User-Agent'] = 'XMLHttpRequest';
    }

    setUpContentTypeRequestHeader() {
        if (this.requestHeaders && this.requestHeaders['Content-type']) { return };
        if (this.isPostRequest() && this.params) {
            this.requestHeaders['Content-type'] = 'application/x-www-form-urlencoded'
        };
    }

    calcRequestUrl() {
        if (!this.params) { return this.url };
        if (this.isPostRequest()) { return this.url }; // Any params are passed separately from the URL.
        if (this.params) { return [this.url,this.params].join('?') };
        return this.url;
    }

    isPostRequest() {
        const re = RegExp('POST','i');
        return re.test(this.method);
    }

    handleLoadStart() {
        this.setLoadingState(true);
    }

    handleLoadEnd() {
        this.setLoadingState(false);
    }

    handleLoad() {
        if (this.xhr.status == 200 && this.xhr.response) {
            this.processSuccessfulResponse();
        } else {
            this.processFailedResponse();
        }
    }

    processSuccessfulResponse() {
        if (typeof this.callback !== 'function') { console.log('Loader callback is not a function', this); return }
        this.callback( this.parsedResponse() );
    }

    processFailedResponse() {
        console.error('FAILURE: ' + this.xhr.status);
        if (this.failureCallback) {
            this.failureCallback( this.parsedResponse() );
        } else {
            this.callback(null);
        }
    }

    parsedResponse() {
        return this.xhr.response;
    }

    setLoadingState(state) {
    }

}



